import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	var obj = {
		formlist: [
		// {
		// 	prop: "thisUserPeriod",
		// 	label: "本月值",
		// 	type: "input",
		// 	slot: true
		// },
		// {
		// 	prop: "samePeriodLastYearUserValue",
		// 	label: "同期值",
		// 	type: "input",
		// 	slot: true
		// },
		{
			prop: "benqlj",
			label:"本月累计",
			type:"input",
			slot: true
		},
		],
		zbdlData: [{
			zbdlvalue: '0',
			label: '税收监控'
		}],
		yjvaluedata: [{
				zbdlvalue: '1',
				label: '浮动百分比'
			},
			{
				zbdlvalue: '2',
				label: '数值'
			}
		],
		boldata: [{
			zbdlvalue: '5',
			label: '等于'
		}, {
			zbdlvalue: '3',
			label: '大于'
		}, {
			zbdlvalue: '4',
			label: '大于等于'
		}, {
			zbdlvalue: '6',
			label: '小于'
		}, {
			zbdlvalue: '7',
			label: '小于等于'
		}, {
			zbdlvalue: '1',
			label: '区间内'
		}, {
			zbdlvalue: '2',
			label: '区间外'
		}],
		zbdldata: [{
			zbdlvalue: '0',
			label: '税负率指标'
		}, {
			zbdlvalue: '1',
			label: '销售指标'
		}, {
			zbdlvalue: '2',
			label: '存货指标'
		}, {
			zbdlvalue: '3',
			label: '预收账款指标'
		}, {
			zbdlvalue: '4',
			label: '期间费用指标'
		}, {
			zbdlvalue: '5',
			label: '黑名单管理'
		}, {
			zbdlvalue: '6',
			label: '其他'
		}],
		shaidiag: true,

		options: [{
			value: '选项1',
			label: '黄金糕'
		}, {
			value: '选项2',
			label: '双皮奶'
		}, {
			value: '选项3',
			label: '蚵仔煎'
		}, {
			value: '选项4',
			label: '龙须面'
		}, {
			value: '选项5',
			label: '北京烤鸭'
		}],
		searchlist: [{
			prop: "type",
			label: '指标类型',
			type: "select",
			selectval: comMapping.$zblx
		}, {
			prop: "name",
			label: '指标名称',
			type: "input"
		}, {
			prop: "category",
			label: '指标大类',
			type: "select",
			selectval: comMapping.$zbdl
		}, {
			prop: "enable",
			label: '是否启用',
			type: "select",
			selectval: [{
				value: '0',
				label: '是'
			}, {
				value: '1',
				label: '否'
			}]
		}, {
			prop: "shuibId",
			label: '税表名称',
			type: "select",
			selectval: [],
		}, {
			prop: "overYuj",
			label: '是否超过预警值',
			type: "select",
			selectval: [{
				value: '0',
				label: '是'
			}, {
				value: '1',
				label: '否'
			}]
		}, {
			prop: "updateTimes",
			label: '最新更新时间',
			type: "date",
			valueformat: 'yyyy-MM-dd'
		}, ],
		searchdata: {
			type: '',
			name: '',
			indexNo: '',
			category: '',
			enable: '',
			overYuj: '',
			time: '',
			shuibId: '',
		},
		searchdataxzmx: {
			btxz: "",
			btywkmdm: "",
			btsbsz: "",
			btbbmc: "",
			btsjly: "",

		},
		tableData: [],
		headData: [{
				title: "指标大类",
				prop: "category",
				width: "80",
				custom: true
			},
			{
				title: "指标类型",
				prop: "type",
				width: "100",
				custom: true
			},

			{
				title: "指标名称",
				prop: "name",
				width: 100,
				align: "left",
				custom: true
			},
			{
				title: "税表名称",
				prop: "shenbType",
				width: 100,
				align: "left",
				custom: true
			},
						{
				title: "预警值",
				prop: "valveValue",
				width: "100",
				custom: true
			},
			// {
			// 	prop: "thisUserPeriod",
			// 	title: "本月",
			// 	width: 100,
			// 	custom: true
			// },{
			// 	prop: "samePeriodLastYearUserValue",
			// 	title: "同期",
			// 	width: 100,
			// 	custom: true
			// }, 
			// {
			// 	title: "指标值",
			// 	prop: "nowValue",
			// 	width: "100",
			// 	custom: true
			// },
			{
				title: "本月累计",
				prop: "benqlj",
				width: "100",
				custom: true
			},{
				title: "同月累计",
				prop: "tongqlj",
				width: "100",
				custom: true
			},
			{
				title: "是否超过预警值",
				prop: "overYuj",
				width: "120",
				custom: true
			}, {
				title: "风险计算时间",
				custom: true,
				prop: "riskCalculationTime",
				width: 160,
			},
			{
				title: "是否启用",
				prop: "enable",
				width: "80",
				custom: true
			}, {
				title: "计算公式",
				prop: "calculationFormula",
				width: "80",
				custom: true
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		suibiaomc: [{
			title: "申报种类",
			prop: "reportName",

		}],
		suibiaomcData: [],
		xzmxbt: [{
			title: "选择",
			prop: "id",
			width: "80",
			custom: true
		}, {
			title: "业务科目代码",
			prop: "yewkmCode",
			width: 160,
			align: "left"

		}, {
			title: "申报税种",
			prop: "shuizmc",
			width: 160,
			align: "left"

		}, {
			title: "报表名称",
			prop: "reportName",
			width: 160,
			align: "left"

		}, {
			title: "数据来源",
			prop: "laiy",
			width: "80",
			custom: true

		}],
		xzmxData: [],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		paginationxzmx: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0

		},
		paginationsbmc: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		paginationHistory: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},



		searchlistzc: [{
				prop: "policyTitle",
				label: '标题',
				type: "input"
			},
			{
				prop: "policyType",
				label: '政策类型',
				type: "select",
				selectval: comMapping.$sszskzclx,
			},
			{
				prop: "isValid",
				label: '是否失效',
				type: "select",
				selectval: [{
						label: "是",
						value: "1"
					},
					{
						label: "否",
						value: "2"
					}
				],
			},
		],
		headDatazc: [{
				title: "标题",
				prop: "policyTitle",
				width: 160,
				align: "left"
			},
			{
				title: "发文字号",
				prop: "policyNum",
				width: "80",
			},
			{
				title: "相关文档",
				prop: "policyFile",
				width: "80"
			},
			{
				title: "是否失效",
				prop: "isValid",
				width: "80",
				custom: true
			},
			{
				title: "政策类型",
				prop: "policyType",
				width: "80",
				custom: true

			},
			{
				title: "相关税种",
				prop: "xianggxz",
				width: "80"
			},
			{
				title: "发文日期",
				prop: "fabTime",
				width: 160,
				align: "left"
			},
			{
				title: "施行日期",
				prop: "implementTime",
				width: 160,
				align: "left"
			},
			{
				title: "发文机构",
				prop: "fbdanw",
				width: 160,
				align: "left"
			},
		],
		historyData:[
			
			{
				title: "历史值",
				prop: "historicalValue",
				width: 80,
				align: "center"
			},
			{
				title: "当前值",
				prop: "currentValue",
				width: 80,
				align: "center"
			},
			{
				title: "修改时间",
				prop: "createTime",
				width: 80,
				align: "center"
			}
		],
		paginationzc: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},

	}
	return obj
}
